import { render, staticRenderFns } from "./CreateMilestone.vue?vue&type=template&id=7ffa7e6c"
import script from "./CreateMilestone.vue?vue&type=script&lang=js"
export * from "./CreateMilestone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports